import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getMyProfile } from "../../../slices/1-auth/2-myProfile/thunk";
import { logout } from "../../../slices/1-auth/1-login/reducer";
// import { getMyProfile } from "../store/profileSlice";
// import { logout } from "../store/authSlice";

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.auth);
  const { error, loading } = useSelector((state) => state.myProfile);
  const tokenData = JSON.parse(localStorage.getItem("authUser"));
  const tokenSession = tokenData?.data?.token;
  useEffect(() => {
    if (token) {
      dispatch(getMyProfile());
    }
  }, [token, dispatch]);

  if (!tokenSession) {
    return <Navigate to="/login" replace />;
  }

  if (error === "TOKEN_EXPIRED") {
    dispatch(logout());
    return <Navigate to="/login" replace />;
  }


  return children;
};

export default ProtectedRoute;
